import type React from 'react'

type Props = {
  disabled?: boolean
}

const MobileFrame: React.FC<Props> = ({ disabled }) => (
  <svg
    width="48"
    height="32"
    viewBox="0 0 48 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.7"
      y="0.7"
      width="62.6"
      height="46.6"
      rx="11.3"
      stroke={disabled ? '#ACBDD3' : '#2F7FEF'}
      strokeWidth="1.4"
      strokeOpacity={disabled ? 0.75 : 1}
    />
    <path
      d="M24 0H72C72 1.86377 72 2.79565 71.6955 3.53073C71.2895 4.51085 70.5108 5.28954 69.5307 5.69552C68.7957 6 67.8638 6 66 6H30C28.1362 6 27.2044 6 26.4693 5.69552C25.4892 5.28954 24.7105 4.51085 24.3045 3.53073C24 2.79565 24 1.86377 24 0Z"
      fill={disabled ? '#ACBDD3' : '#2F7FEF'}
      fillOpacity={disabled ? 0.75 : 1}
    />
  </svg>
)

export default MobileFrame
